import React from "react";
import "../css/homepage.css";
import { Link } from "react-router";

export const HeroImg = () => {
  return (
    <div className="container">
      <div className="banner-container">
        <div className="banner-img">
          <img
            className="desktop-view"
            src="/assets/homepageBanner.webp"
            alt="banner"
          />
          <img
            className="mobile-view"
            src="/assets/homeBannerMob.webp"
            alt="banner"
          />
        </div>
      </div>
    </div>
  );
};

export const HomePageSectionTop = () => {
  return (
    <div className="container">
      <div className="top-homepage">
        <h1 className="top-home-heading">
          Your Partner in Expert Real Estate Lease and Financial Due Diligence
        </h1>
        <p className="top-home-detail">
          Continental Lease Advisors is a boutique consulting firm with a highly
          personalized approach to client service. We are the premier provider
          of outsourced lease and financial due diligence, and operational
          consulting services to national equity and debt investors in
          commercial real estate throughout North America.
        </p>
        <Link className="cta-home" to="/about">
          <button className="submit-btn">About Us →</button>
        </Link>
      </div>
    </div>
  );
};

export const HomePageSectionBottom = () => {
  const cardData = [
    {
      img: "/assets/h1.png",
      title: "RETAIL",
      desc: "Breadth of Expertise from single tenant retail building to 3M SF entertainment / retail center",
    },
    {
      img: "/assets/h2.png",
      title: "INDUSTRIAL",
      desc: "Breadth of Expertise from single tenant industrial building to 100+ property, 4M SF portfolio",
    },
    {
      img: "/assets/h3.png",
      title: "OFFICE",
      desc: "Breadth of Expertise from single tenant office building to 2M SF office tower",
    },
    {
      img: "/assets/h4.png",
      title: "MEDICAL OFFICE",
      desc: "Breadth of Expertise from single tenant medical office building to 64 property, 2.7M SF portfolio",
    },
    {
      img: "/assets/h5.png",
      title: "MULTI-FAMILY HOUSING",
      desc: "Breadth of Expertise from single multifamily property to 1,000+ unit portfolio",
    },
    {
      img: "/assets/h6.png",
      title: "MANUFACTURED HOUSING",
      desc: "Breadth of Expertise from single property to  1,500+ unit portfolio",
    },
  ];
  return (
    <div className="container">
      <div className="heading-page ">
        <h1 className="home-heading">
          <img src="/assets/icons/flag.svg" alt="" />
          <span className="heading-red">ASSET CLASSES</span>
          <br />
        </h1>
        <span className="heading-nextline">WE SERVICE</span>
      </div>
      <div className="home-card-container">
        {cardData.map((card, index) => (
          <div key={index} className="home-card">
            <img src={card.img} alt="banner" />
            <h2 className="home-card-title">{card.title}</h2>
            <p className="home-card-detail">{card.desc}</p>
          </div>
        ))}
      </div>
      <Link to="/services">
        <button className="submit-btn center-align">Services →</button>
      </Link>
    </div>
  );
};
